"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.willMountComponent = willMountComponent;
exports.didMountComponent = didMountComponent;
exports.willUnmountComponent = willUnmountComponent;
exports.mountRootComponent = mountRootComponent;
function willMountComponent(store, componentInstance, path) {
	componentInstance.__manualMount = true;
	componentInstance.__willMount(store, path, null);
	return componentInstance.reducer;
}

function didMountComponent(componentInstance) {
	componentInstance.__didMount();
}

function willUnmountComponent(componentInstance) {
	componentInstance.__willUnmount();
}

function mountRootComponent(store, componentInstance) {
	var reducer = willMountComponent(store, componentInstance, []);
	store.replaceReducer(reducer);
	didMountComponent(componentInstance);
}